import { render, staticRenderFns } from "./Give.vue?vue&type=template&id=400c39c5&scoped=true&"
import script from "./Give.vue?vue&type=script&lang=js&"
export * from "./Give.vue?vue&type=script&lang=js&"
import style0 from "./Give.vue?vue&type=style&index=0&id=400c39c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c39c5",
  null
  
)

export default component.exports